
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/festival-interlagos-2024-motos",
      function () {
        return require("private-next-pages/blog/festival-interlagos-2024-motos.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/festival-interlagos-2024-motos"])
      });
    }
  